import React from 'react';
import { StyleSheet } from 'react-native';
import { Box } from 'native-base';
const DEFAULT_ITEM_HEIGHT = 48;
const styles = StyleSheet.create({
    selectedOutline: {
        width: '100%',
    },
    selectedOutlineInner: {
        flex: 1,
    },
});
export const ADCSelectedOutline = ({ height = DEFAULT_ITEM_HEIGHT, withStyles, }) => {
    const borderRadius = 8;
    const outerBorderWidth = 5;
    const outerBorderRadius = borderRadius + outerBorderWidth;
    return (React.createElement(Box, { backgroundColor: "neutral.container", borderColor: "interactive.secondary.focus.strokeOpacity", borderRadius: outerBorderRadius, borderWidth: outerBorderWidth, height: height + outerBorderWidth, style: [styles.selectedOutline, withStyles] },
        React.createElement(Box, { borderColor: "interactive.secondary.focus.defaultStroke", borderRadius: borderRadius, borderWidth: 1, height: height, style: styles.selectedOutlineInner })));
};
